import { render, staticRenderFns } from "./customTitle.vue?vue&type=template&id=60e2a506&scoped=true&"
import script from "./customTitle.vue?vue&type=script&lang=js&"
export * from "./customTitle.vue?vue&type=script&lang=js&"
import style0 from "./customTitle.vue?vue&type=style&index=0&id=60e2a506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2a506",
  null
  
)

export default component.exports